export interface IObjectUrlService {
    createObjectUrl(blob: Blob): string;
    revokeObjectUrl(url: string): void;
}

export class ObjectUrlService implements IObjectUrlService {
    createObjectUrl(blob: Blob): string {
        return window.URL.createObjectURL(blob);
    }

    revokeObjectUrl(url: string): void {
        window.URL.revokeObjectURL(url);
    }
}



// WEBPACK FOOTER //
// ./src/services/object-url-service.ts